export default __webpack_public_path__ + "static/media/logoOnboardBlack.b21728af.svg";